import { connect } from 'pwa-helpers';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import store from '../../store/store';
import { BaseComponent } from '../base-component/base-component';
import { userSignout } from '../user-profile/thunks/user-signout.thunk';
import emit from '../../common/events';
import environment from '../../common/environment';
import { getAppFlow } from '../user-profile/utils/user-profile.util';

@customElement('mhecomm-signout')
export class Signout extends connect(store)(BaseComponent) {

  renderComp() {
    return html` <button
      class="btn btn-outline-primary link-type-shopLogout w-100"
      data-layer-comp="button"
      data-layer-target="btn-sign-out"
      id="btn-sign-out"
      data-layer-link-type="shopLogout"
      target="_self"
      @click=${() => this.signout()}
    >
      Sign Out
    </button>`;
  }

  async signout() {
    await store.dispatch(userSignout());
    emit({
      element: this,
      name: 'click',
      detail: {
        label: 'Sign Out',
        id: 'btn-sign-out',
        comp: 'button',
        target: 'btn-sign-out',
        linkType: 'shopLogout',
        subarea: 'globalnav',
        href: window.location.href,
        area: 'header',
        appFlow: getAppFlow(),
      },
      dataLayer: true
    });
    
    const queryParams = new URL(location.href).searchParams;
    window.location.href = `${environment().shopUrl}/login?${queryParams.toString()}`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-signout': Signout;
  }
}
